import ArrayHelper from './ArrayHelper.js';
import ObjectHelper from './ObjectHelper.js';

export default class DataHelper {
  static cloneData(data) {
    return JSON.parse(JSON.stringify(data));
  }

  static isEmpty(value) {
    return [undefined, '', null, '0-0'].indexOf(value) !== -1 || ArrayHelper.isEmpty(value) || ObjectHelper.isEmpty(value);
  }

  static filterDeeply(data) {
    Object.keys(data).forEach(k => {
      if (this.isEmpty(data[k])) {
        delete data[k];
      } else if (typeof (data[k]) === 'object') {
        this.filterDeeply(data[k]);
      }
    });
    return data;
  }
}
